export const DP_SEARCH_VIEW = 'search';
